import type { PersistWorkoutStep } from "./workoutSave.js";

// Idempotency-Key derivation for the workout outbox. Pure function of
// `itemId` + step shape, no time/random components, so the same
// PendingWorkout.id always yields the same per-step keys across retries
// and process death. The server's idempotency middleware dedupes
// replays without a separate seed on the row. Verified for MOB-2
// (CODE_REVIEW.md): no schema change needed.
//
// Lifted from apps/mobile/src/outbox/idempotencyKey.ts in 1.34.0. Web
// has no offline outbox today, but `workoutSave.persistWorkout()`'s
// optional `idempotencyKeyFor?: (step) => string` parameter accepts
// this generator if/when a web-side queue lands. Keeping the derivation
// in shared means the contract stays in sync ahead of that work.
//
// Same lift required jest's moduleNameMapper to strip `.js` extensions
// from relative imports inside this package — without it, the mobile
// test transitively pulls in the shared barrel and crashes on the
// first `export * from "./schemas/health.js"`. See
// `apps/mobile/jest.config.js`.
export const keyForOutboxItem =
  (itemId: string) =>
  (step: PersistWorkoutStep): string => {
    switch (step.kind) {
      case "session":
        return `${itemId}-session`;
      case "sets-batch":
        return `${itemId}-sets-${step.chunk}`;
      case "orphan-cleanup":
        return `${itemId}-orphan-cleanup`;
      case "sets-replace":
        return `${itemId}-sets-replace`;
    }
  };
